import {all} from "redux-saga/effects";
import VideoSaga from "../common/video/VideoSaga";
import SearchSaga from "../viewer/search/SearchSaga";
import PresentersSaga from "../viewer/presenters/PresentersSaga";
import UserSaga from "../user/UserSaga";
import HomePageSaga from "../common/homePage/HomePageSaga";
import ExProjectSaga from "../store/sagas/ExProjectSaga";
import ExVideoSaga from "../store/sagas/ExVideoSaga";
import SurveySaga from "../store/sagas/SurveySaga";

export default function* rootSaga() {
    yield all([
        HomePageSaga(),
        VideoSaga(),
        SearchSaga(),
        PresentersSaga(),
        UserSaga(),
        ExProjectSaga(),
        ExVideoSaga(),
        SurveySaga()
    ]);
}
